// @TODO: set english help content

import frenchHelpContent from '../fr/helpContent';

export default frenchHelpContent;
